<template>
  <div class="2xl:container mt-20 mb-32 relative flex flex-col">
    <CardSliderNav
      v-if="slides.length > 1"
      ref="nav"
      class="absolute top-0 right-4 sm:right-16 lg:right-0 mt-8 sm:mr-8 z-20"
      @prev="() => $refs.slider.prev()"
      @next="() => $refs.slider.next()"
    />
    <FixedAspect :ratio="1" class="w-full md:w-1/2 lg:-mt-10 z-10">
      <CardSlider
        v-if="slides && slides.length"
        ref="slider"
        :slide-gap="0"
        :show-arrows="false"
        :fullwidth-slides="true"
        :is-container="false"
        :breakpoints="breakpoints"
        @change="(innerState) => setActiveSlide(innerState)"
      >
        <div v-for="slide in slides" :key="slide.id" class="article-wrapper relative">
          <CldnImg
            v-if="slide.overlayImage.length"
            :src="slide.overlayImage[0].url"
            sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
            crop="fill"
            class="max-w-none h-full w-full absolute top-0 left-0 z-10 block object-cover"
            :alt="slide.overlayImage[0].title"
          />
          <FixedAspect :ratio="1" class="w-full">
            <CraftAsset
              v-if="slide.image.length"
              :alt="slide.alt"
              :asset="slide.image[0]"
              sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
              crop="fill"
              class="max-w-none absolute inset-0 z-0 block object-cover w-full h-full"
              :autoplay="true"
            />
          </FixedAspect>
        </div>
      </CardSlider>
    </FixedAspect>
    <div
      class="md:items-end md:flex md:flex-row md:absolute md:inset-0 md:justify-end mt-4 md:mt-20 pointer-events-none"
      :style="styleHeight"
    >
      <div
        class="md:pr-10 md:py-20 md:w-7/12 md:pl-40 md:h-full z-0 p-8 pb-12"
        :class="[
          {
            'bg-blackly text-white': !appearance || appearance === 'black',
            'bg-br-green-light text-blackly': appearance === 'lightGreen',
          },
        ]"
      >
        <transition name="fade" mode="out-in">
          <div v-if="currentSlide" class="inner h-full pointer-events-auto" :key="currentSlide.id">
            <div ref="boxes" class="black-box flex flex-wrap flex-initial h-full">
              <div class="w-full mb-4 fluid-xl leading-tight" v-html="currentSlide.heading"></div>
              <div class="text-copy lg:mb-0 w-full mb-4 fluid-base checkmark-bullets" v-html="currentSlide.body"></div>
              <FixedAspect :ratio="2 / 10" class="self-end w-full">
                <CldnImg
                  v-if="currentSlide.productAttributes?.length"
                  :src="currentSlide.productAttributes[0]?.url"
                  crop="fill"
                  sizes="100vw sm:100vw md:100vw lg:50vw xl:50vw 2xl:50vw"
                  class="max-w-none absolute inset-0 z-0 block object-cover w-full h-full"
                  :alt="currentSlide.alt"
                />
              </FixedAspect>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import FixedAspect from '~/components/common/FixedAspect';
import CldnImg from '~/components/CldnImg';
import CraftAsset from '~/components/common/CraftAsset';
import CardSlider from '~/components/common/CardSlider';
import CardSliderNav from '~/components/common/CardSliderNav';

export default defineNuxtComponent({
  name: 'SplitContentSlider',
  components: {
    CardSliderNav,
    CardSlider,
    CraftAsset,
    FixedAspect,
    CldnImg,
  },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
    appearance: {
      type: String,
      default: 'black',
      validator: (value) => ['black', 'lightGreen'].includes(value),
    },
  },
  data() {
    return {
      currentSlide: null,
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      ],
      boxMinHeight: 0,
    };
  },
  computed: {
    styleHeight() {
      return {
        'min-height': this.boxMinHeight + 'px',
      };
    },
  },
  mounted() {
    this.adjustSlidesHeight();
    window.addEventListener('resize', this.adjustSlidesHeight);
  },
  methods: {
    setActiveSlide(state) {
      if (typeof state !== 'object' && !state) return;
      this.$refs.nav?.handleSliderChange(state);
      this.currentSlide = this.slides[state?.currentSlide];
    },
    adjustSlidesHeight() {
      this.boxMinHeight = this.$refs.slider?.$el?.getBoundingClientRect()?.height ?? 0;
    },
  },
});
</script>
<style scoped>
@reference "~/assets/css/main.css";
.fade-enter-active,
.fade-leave-active {
  @apply transition-opacity duration-200;
}
.fade-enter,
.fade-leave-active {
  @apply opacity-0;
}
</style>
